module.exports = __webpack_public_path__ + "static/Blue-d9565db536737f56d352c342cde59fff.png";